import advantagesJson from "../../data/pluginAndAppDevelopmentAdvantages.json";

export default function Section5() {
  const bgImage = {
    backgroundImage: "url('assets/bg-reviews-shopify.webp')",
  };

  const advantagesData = advantagesJson;

  return (
    <div
      className="w-full Section5 my-[40px] md:mt-[2%] p-[2%_2%_2.5%_2%] md:p-[2%] text-center md:mb-[5%]"
      style={bgImage}
    >
      <div className="w-full section4-container">
        <h2 className="text-[24px] md:text-[34px] font-bold leading-[30px] my-[0.67em] text-white">
          Advantages Of Our Custom Plugin & App Development
        </h2>

        <div className="flex flex-col md:flex-row pt-0 md:pt-[45px] boxes mx-auto md:w-[95%] xl:w-[80%]">
          {advantagesData.map(({title, text}, index) => (
            <div
              key={title}
              className={`bg-white box-${index + 1} rounded-[10px] p-[15px_20px] my-[5px] mx-[8px]  md:m-[10px_8px]`}
            >
              <h3 className="text-base leading-[26px] font-bold my-[0.67em] capitalize">
                {title}
              </h3>
              <p className="text-[#373737] mb-5 text-[14px] font-open">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
